import * as React from "react";

const CopyIcon = (props) => (
  <svg
    width={13}
    height={16}
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.895 0H1.368C.616 0 0 .616 0 1.368v8.895c0 .377.308.684.684.684a.686.686 0 00.684-.684v-8.21c0-.377.308-.685.685-.685h6.842a.686.686 0 00.684-.684A.686.686 0 008.895 0zm2.737 2.737H4.105c-.752 0-1.368.616-1.368 1.368v9.58c0 .752.616 1.368 1.368 1.368h7.527c.752 0 1.368-.616 1.368-1.369V4.105c0-.752-.616-1.368-1.368-1.368zM4.789 13.684h6.158a.686.686 0 00.685-.684V4.79a.686.686 0 00-.685-.685H4.79a.686.686 0 00-.684.684V13c0 .376.308.684.684.684z"
      fill="#404D61"
    />
  </svg>
);

export default CopyIcon;
